import React from 'react';
import {
  DataSource,
  DATA_SOURCE_LABEL,
  DATA_SOURCE_COLOR,
} from '../../lib/dataSources';

interface Props {
  source?: DataSource;
}

const DataSourceBadge: React.FC<Props> = ({ source }) => {
  if (!source) return null;
  const color = DATA_SOURCE_COLOR[source] || 'bg-gray-700';
  return (
    <span
      className={`inline-flex flex-shrink-0 items-center px-3 py-1 rounded-full text-xs font-medium text-white whitespace-nowrap ${color}`}
    >
      {DATA_SOURCE_LABEL[source]}
    </span>
  );
};

export default DataSourceBadge;

